var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiloDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 145,
    viewBox: "0 0 13 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.96 12V0.799999H4.36V5.872L8.84 0.799999H11.752L7.608 5.472L12.024 12H9.144L5.912 7.232L4.36 8.992V12H1.96Z",
    fill: "#ffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.544 145H0.064L4.16 133.8H7.04L11.104 145H8.528L7.664 142.552H3.408L2.544 145ZM5.52 136.36L4.048 140.616H7.008L5.52 136.36Z",
    fill: "#ffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18L0.226497 28L11.7735 28L6 18ZM6 127L11.7735 117L0.226493 117L6 127ZM5 27L5 118L7 118L7 27L5 27Z",
    fill: "#ffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiloDivider);
export default __webpack_public_path__ + "static/media/hilo-divider.b2bb7eba14346eae548466c0f78fb3d5.svg";
export { ForwardRef as ReactComponent };